import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'fee'

export const CREATE_FEE = createRequestTypes(prefix, 'CREATE_FEE')

export const [CREATE_FEE_REQUEST, CREATE_FEE_SUCCESS, CREATE_FEE_FAILURE] = CREATE_FEE

export const createFee = createAction((data: object) => ({
  type: CREATE_FEE,
  promise: (api: IApi) => api.fee.create(data),
}))

const UPDATE_FEE = createRequestTypes(prefix, 'UPDATE_FEE')

export const [UPDATE_FEE_REQUEST, UPDATE_FEE_SUCCESS, UPDATE_FEE_FAILURE] = UPDATE_FEE

export const updateFee = createAction((id: string, data: object) => ({
  type: UPDATE_FEE,
  promise: (api: IApi) => api.fee.update(id, data),
}))

const RESTORE_FEE = createRequestTypes(prefix, 'RESTORE_FEE')

export const [RESTORE_FEE_REQUEST, RESTORE_FEE_SUCCESS, RESTORE_FEE_FAILURE] = RESTORE_FEE

export const restoreFee = createAction((id: string) => ({
  type: RESTORE_FEE,
  promise: (api: IApi) => api.fee.restore(id),
}))

const DELETE_FEE = createRequestTypes(prefix, 'DELETE_FEE')

export const [DELETE_FEE_REQUEST, DELETE_FEE_SUCCESS, DELETE_FEE_FAILURE] = DELETE_FEE

export const deleteFee = createAction((id: string) => ({
  type: DELETE_FEE,
  promise: (api: IApi) => api.fee.delete(id),
}))

const PERMANENT_DELETE_FEE = createRequestTypes(prefix, 'PERMANENT_DELETE_FEE')

export const [
  PERMANENT_DELETE_FEE_REQUEST,
  PERMANENT_DELETE_FEE_SUCCESS,
  PERMANENT_DELETE_FEE_FAILURE,
] = PERMANENT_DELETE_FEE

export const permanentDeleteFee = createAction((id: string) => ({
  type: PERMANENT_DELETE_FEE,
  promise: (api: IApi) => api.fee.permanentDelete(id),
}))
